if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMinusBulk = this.querySelector('.qty-minus-bulk'),
						qtyPlusBulk = this.querySelector('.qty-plus-bulk');
			let	qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
			this.warningWrapper = this.closest("[data-warning-message-wrapper]")?.querySelector("[data-product-form-warning]");


			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
				if(qtyMinusBulk) qtyMinusBulk.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
				if(qtyPlusBulk) qtyPlusBulk.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
				qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
					if(qtyMinusBulk) qtyMinusBulk.classList.add('disabled');
					qtyMinus.classList.add("data-value-changed");
				} else {
					qtyMinus.classList.remove('disabled');
					if(qtyMinusBulk) qtyMinusBulk.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
					if(qtyPlusBulk) qtyPlusBulk.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
					if(qtyPlusBulk) qtyPlusBulk.classList.remove('disabled');
				}

				if(parseInt(qty.value) < qtyMin && qtyMin > 1) {
					qty.value = qtyMin;
					this.showQuantityWarning();
				}				
				else {
					this.hideQuantityWarning();
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
				qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
				e.preventDefault();

				if(parseInt(qty.value) - 1 < qtyMin && qtyMin > 1) {
					this.showQuantityWarning();
				}
				else {
					this.hideQuantityWarning();
				}
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
						qtyMinus.classList.add("data-value-changed");
					}
					
					qty.dispatchEvent(
						new CustomEvent("inputChangedByButtons", {
						  bubbles: true,
						  detail: { value: qty.value },
						}),
					);
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
				qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}

					qty.dispatchEvent(
						new CustomEvent("inputChangedByButtons", {
						  bubbles: true,
						  detail: { value: qty.value },
						}),
					);
				}

				if(parseInt(qty.value) - 1 < qtyMin && qtyMin > 1) {
					this.showQuantityWarning();
				}
				else {
					this.hideQuantityWarning();
				}
			});

			if(qtyMinusBulk) {
				qtyMinusBulk.addEventListener('click', (e)=>{
					e.preventDefault();
					if ( ! qtyMinusBulk.classList.contains('disabled') ) {
						const currentQty = parseInt(qty.value);
						if ( currentQty - 10 >= qtyMin ) {
							qty.value = currentQty - 10;
							qtyPlus.classList.remove('disabled');
							qtyPlusBulk.classList.remove('disabled');
						} 
						if ( currentQty - 10 <= qtyMin ) {
							qtyMinus.classList.add('disabled');
							qtyMinusBulk.classList.add('disabled');
						}
						
						qty.dispatchEvent(
							new CustomEvent("inputChangedByButtons", {
							  bubbles: true,
							  detail: { value: qty.value },
							}),
						);
					}
				});
			}

			if(qtyPlusBulk) {
				qtyPlusBulk.addEventListener('click', (e)=>{
					e.preventDefault();
					if ( ! qtyPlusBulk.classList.contains('disabled') ) {
						const currentQty = parseInt(qty.value);
						if ( currentQty + 10 <= qtyMax ) {
							qty.value = currentQty + 10;
							qtyMinus.classList.remove('disabled');
							qtyMinusBulk.classList.remove('disabled');
						} 
						if ( currentQty + 10 >= qtyMax ) {
							qtyPlus.classList.add('disabled');
							qtyPlusBulk.classList.add('disabled');
						}
	
						qty.dispatchEvent(
							new CustomEvent("inputChangedByButtons", {
							  bubbles: true,
							  detail: { value: qty.value },
							}),
						);
					}
				});
			}

		}

		showQuantityWarning() {
			if(!this.warningWrapper) return;
			this.warningWrapper.innerHTML = this.warningWrapper.getAttribute("data-warning-message");
		}
		
		hideQuantityWarning() {
			if(!this.warningWrapper) return;
			this.warningWrapper.innerHTML = "";
		}
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}